var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=xl, Color=Warning, Theme=Dark circle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F79009"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#DC6803",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "alert-triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M32.9999 28.3332V32.9999M32.9999 37.6666H33.0116M31.0049 22.3366L21.1232 38.8332C20.9195 39.1861 20.8117 39.5861 20.8106 39.9935C20.8094 40.4009 20.915 40.8016 21.1167 41.1555C21.3185 41.5095 21.6094 41.8045 21.9606 42.0111C22.3117 42.2177 22.7108 42.3288 23.1182 42.3332H42.8816C43.289 42.3288 43.6881 42.2177 44.0392 42.0111C44.3904 41.8045 44.6813 41.5095 44.8831 41.1555C45.0848 40.8016 45.1904 40.4009 45.1892 39.9935C45.1881 39.5861 45.0803 39.1861 44.8766 38.8332L34.9949 22.3366C34.7869 21.9937 34.4941 21.7102 34.1446 21.5135C33.7952 21.3167 33.4009 21.2134 32.9999 21.2134C32.5989 21.2134 32.2046 21.3167 31.8552 21.5135C31.5057 21.7102 31.2129 21.9937 31.0049 22.3366Z",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningLive);
export default __webpack_public_path__ + "static/media/warning-live.8cb837df774292b26a6178fab4efcbd1.svg";
export { ForwardRef as ReactComponent };